<template>
  <base-modal form :title="`Edit ${pricing.role.title} Pricing`">
    <div class="columns is-multiline">
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="pricing.rate"
          :error="errors.rate"
          error-class="has-text-danger">
          Hourly Rate
          <static-button slot="left">R</static-button>
          <static-button slot="right">inc VAT</static-button>
        </formatted-text-input>
      </div>
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="pricing.cleaning"
          :error="errors.cleaning"
          error-class="has-text-danger">
          Cleaning <span class="has-text-weight-light">(8am-5pm)</span>
          <static-button slot="left">R</static-button>
          <static-button slot="right">inc VAT</static-button>
        </formatted-text-input>
      </div>
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="pricing.cleaning_after_hours"
          :error="errors.cleaning_after_hours"
          error-class="has-text-danger">
          Cleaning <span class="has-text-weight-light">(after 5pm, week-ends &amp; public holidays)</span>
          <static-button slot="left">R</static-button>
          <static-button slot="right">inc VAT</static-button>
        </formatted-text-input>
      </div>
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="pricing.security"
          :error="errors.security"
          error-class="has-text-danger">
          Security <span class="has-text-weight-light">(between 5pm and 6pm)</span>
          <static-button slot="left">R</static-button>
          <static-button slot="right">inc VAT</static-button>
        </formatted-text-input>
      </div>
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="pricing.security_after_hours"
          :error="errors.security_after_hours"
          error-class="has-text-danger">
          Security <span class="has-text-weight-light">(after 6pm, week-ends &amp; public holidays)</span>
          <static-button slot="left">R</static-button>
          <static-button slot="right">inc VAT</static-button>
        </formatted-text-input>
      </div>
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="pricing.deposit"
          :error="errors.deposit"
          error-class="has-text-danger">
          Deposit
          <static-button slot="left">R</static-button>
        </formatted-text-input>
      </div>
    </div>
    <div slot="footer" class="buttons">
      <submit-button
        :working="working"
        @submit="save"
        class="is-success is-rounded">
        Save
      </submit-button>
    </div>
  </base-modal>
</template>

<script>
import { mapState } from 'vuex'
import { savePrice } from '@/api/facility'

import find from 'lodash/find'

export default {

  props: {
    payload: Object,
  },

  data:() => ({
    working: false,
    pricing: {}
  }),

  created() {
    this.pricing = { ...this.payload }
  },

  methods: {
    save() {
      this.working = true
      savePrice(this.pricing, () => {
        this.$toast.success('Changes saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }

}
</script>
